<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-plz">
    <main class="tpl-plz__main">
      <header class="tpl-plz__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-plz__logo" />
      </header>

      <p v-if="showHero && quiz.sub_title" class="tpl-plz__hero-sub">{{ quiz.sub_title }}</p>

      <div class="tpl-plz__stepper" aria-hidden="true">
        <span class="tpl-plz__stepper-line"></span>
        <span class="tpl-plz__stepper-dot">&#10003;</span>
        <span class="tpl-plz__stepper-line"></span>
        <span class="tpl-plz__stepper-dot" :class="{ 'tpl-plz__stepper-dot--muted': !isGate }">&#10003;</span>
        <span class="tpl-plz__stepper-line"></span>
      </div>

      <div class="tpl-plz__card">
        <slot />
      </div>

      <footer class="tpl-plz__footer">
        <p v-if="quiz.privacy_url" class="tpl-plz__footer-privacy">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-plz__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-plz__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
